import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { passwordReset, passwordResetFailed, resetPassword, ResetPasswordPayload } from '../../actions/user/resetPassword';
import getPublicResponse from '../getPublicResponse';

function* resetPasswordSaga({ payload }: Action<ResetPasswordPayload>) {
  const { token, newPassword } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.resetPassword, {
    token,
    newPassword,
  });
  if (!response.error && !response.errorType) {
    yield put(passwordReset({}));
  } else {
    yield put(passwordResetFailed({ errorType: response.errorType }));
  }
}

export default function* watchResetPasswordSaga() {
  yield takeEvery(resetPassword, resetPasswordSaga);
}
